import { MutationTree } from "vuex";
import {CdpDetailItem, CdpGroupItem, StatisticState} from "./types";

export const mutations: MutationTree<StatisticState> = {
  setCdpStaticDetail: (state, data: CdpDetailItem[]) => state.cdpStaticDetail = data,
  pushCdpStaticDetail: (state, data: CdpDetailItem[]) => state.cdpStaticDetail = state.cdpStaticDetail.concat(data),
  setCdpStatisticDetailFlag: (state, flag: string) => state.cdpStatisticDetailFlag = flag,
  // setCdpMessagesCount: (state, count: number) => state.cdpStatisticGroupMessageCount = count,
  setCdpStatisticGroup: (state, data: CdpGroupItem[]) => state.cdpStatisticGroup = data
};
